export default [
    {
        header: 'Research',
        action: 'see',
        resource: 'product-research-section',
    },
    {
        title: 'Research Discovery',
        icon: 'SearchIcon',
        route: 'research-discovery-grid',
        activeForRoutes: ['research-discovery-card'],
        action: 'visit',
        resource: 'product-research-discovery',
    },
    {
        title: 'Research Review',
        icon: 'ClipboardIcon',
        route: 'research-review-grid',
        activeForRoutes: ['research-review-card'],
        action: 'visit',
        resource: 'research-review-grid',
    },
]
